
import Vue from 'vue'
import { ContestWinner } from '@/model/Contest'
import PagedResults from '@/service/PagedResults'
import ContestWinnersGroup from '@/components/contest/ContestWinnersGroup.vue'

export default Vue.extend({
  name: 'ContestWinners',
  components: {
    ContestWinnersGroup,
  },
  props: {
    contestId: {
      type: String,
    },
  },
  computed: {
    winnersGrouped: function (): Record<string, ContestWinner[]> {
      const result = {} as Record<string, ContestWinner[]>
      for (let i = 0; i < this.winners.length; i++) {
        const winner = this.winners[i]
        if (!(winner.category in result)) {
          result[winner.category] = []
        }
        result[winner.category].push(winner)
      }
      for (const categoryKey in result) {
        result[categoryKey].sort(
          (a: ContestWinner, b: ContestWinner) => a.place - b.place
        )
      }
      return result
    },
  },
  mounted() {
    this.fetchWinners()
  },
  data: () => ({
    winners: [] as ContestWinner[],
  }),
  methods: {
    fetchWinners: function () {
      const winnersLoader = new PagedResults<ContestWinner[]>(this.$api)
      winnersLoader
        .all('contests/winners', 30, {
          contestId: this.contestId
        })
        .then((result) => (this.winners = result))
    },
  },
})
